import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconExternalLink(props: SvgIconProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M20.5 3.5L7 17M20.5 3.5V10.5M20.5 3.5H13.5M18.5 14.5V20.5H3.5V5.5H9.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={props.strokeWidth ?? 1.5}
      />
    </SVGIcon>
  );
}
